import React, {useRef, useState} from 'react';
//import {updateOpayoSettings} from "../../../../Actions/MopriSettingActions";
import {Toast} from "primereact/toast";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Controller, useForm} from "react-hook-form";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import {faCreditCard} from "@fortawesome/free-solid-svg-icons/faCreditCard";
import {useSelector} from "react-redux";

const opayoStatuses = [{value: true, description: 'Active'}, {value: false, description: 'Inactive'}];
const opayoEnvironments = [{value: true, description: 'Sandbox Environment'}, {value: false, description: 'Live Environment'}];
export const OpayoSettings = (props) => {
    const [submitButtonDisabled, setSubmitButtonDisabled] = useState(false)
    const themeSettings = useSelector(state => state.theme);
    const myToast = useRef(null)

    const { control, handleSubmit, watch, getValues,
        formState: { errors } } = useForm({
        defaultValues: {
            opayoActive: true,
            opayoSandbox: true,
            opayoProductionVendorName: '',
            opayoProductionIntegrationKey: '',
            opayoProductionIntegrationPassword: '',
            opayoSandboxVendorName: '',
            opayoSandboxIntegrationKey: '',
            opayoSandboxIntegrationPassword: '',
        }
    })

    const onSubmit = (data) => {
        setSubmitButtonDisabled(true)

    }

    const getFormErrorMessage = (name) => {
        return errors[name] && <small className="p-error">{errors[name].message}</small>
    };

    const opayoServiceActive = watch("opayoActive")
    const opayoSandboxStatus = watch("opayoSandbox")

    return (
        <>
            <Toast ref={myToast} />
            <div className="p-fluid grid formgrid">
                <div className="field col-12">
                    <h4><FontAwesomeIcon icon={faCreditCard} style={{paddingRight: '10px'}}/> Opayo Settings (SagePay)</h4>
                </div>
            </div>

            <div className="p-fluid grid formgrid">
                <div className="field col-12">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="p-fluid grid formgrid" >
                            <div className="field col-6">
                                <span className="p-float-label" style={{fontSize: '12px', color: "#6c757d", paddingBottom: '5px'}}>
                                     Opayo Status
                                </span>
                                <Controller name="opayoActive" control={control}  rules={{ required: 'Required.' }}
                                            render={({ field, fieldState }) => (
                                                <Dropdown value={field.value} id={field.name}
                                                          options={opayoStatuses} optionLabel="description"
                                                          optionValue="value"
                                                          onChange={(e) => {
                                                              field.onChange(e.value)
                                                          }}
                                                />
                                            )}
                                />
                                {getFormErrorMessage('opayoActive')}
                            </div>
                            <div className="field col-6">
                                {opayoServiceActive &&
                                    <>
                                        <span className="p-float-label" style={{fontSize: '12px', color: "#6c757d", paddingBottom: '5px'}}>
                                         Opayo Status
                                        </span>
                                        <Controller name="opayoSandbox" control={control}  rules={{ required: 'Required.' }}
                                                    render={({ field, fieldState }) => (
                                                        <Dropdown value={field.value} id={field.name}
                                                                  options={opayoEnvironments} optionLabel="description"
                                                                  optionValue="value"
                                                                  onChange={(e) => {
                                                                      field.onChange(e.value)
                                                                  }}
                                                        />
                                                    )}
                                        />
                                        {getFormErrorMessage('opayoSandbox')}
                                    </>
                                }
                            </div>
                        </div>

                        {(opayoServiceActive && !opayoSandboxStatus) &&
                            <>
                                <h5>Opayo Live Environment Settings</h5>
                                <div className="p-fluid grid formgrid" >
                                    <div className="field col-6" style={{paddingTop: '27px'}}>
                                        <span className="p-float-label">
                                            <Controller name="opayoProductionVendorName" control={control}
                                                        render={({ field, fieldState }) => (
                                                            <InputText id={field.name} {...field}
                                                            />
                                                        )}
                                            />
                                            <label htmlFor="opayoProductionVendorName">Opayo Vendor Name</label>
                                        </span>
                                        {getFormErrorMessage('opayoProductionVendorName')}
                                    </div>
                                    <div className="field col-6" style={{paddingTop: '27px'}}>
                                        <span className="p-float-label">
                                            <Controller name="opayoProductionIntegrationKey" control={control}
                                                        render={({ field, fieldState }) => (
                                                            <InputText id={field.name} {...field}
                                                            />
                                                        )}
                                            />
                                            <label htmlFor="opayoProductionIntegrationKey">Opayo Integration Key</label>
                                        </span>
                                        {getFormErrorMessage('opayoProductionIntegrationKey')}
                                    </div>
                                    <div className="field col-6" style={{paddingTop: '27px'}}>
                                        <span className="p-float-label">
                                            <Controller name="opayoProductionIntegrationPassword" control={control}
                                                        render={({ field, fieldState }) => (
                                                            <InputText id={field.name} {...field}
                                                            />
                                                        )}
                                            />
                                            <label htmlFor="opayoProductionIntegrationPassword">Opayo Integration Password</label>
                                        </span>
                                        {getFormErrorMessage('opayoProductionIntegrationPassword')}
                                    </div>
                                </div>
                            </>
                        }

                        {(opayoServiceActive && opayoSandboxStatus) &&
                            <>
                                <h5>Opayo Sandbox Environment Settings</h5>
                                <div className="p-fluid grid formgrid" >
                                    <div className="field col-6" style={{paddingTop: '27px'}}>
                                        <span className="p-float-label">
                                            <Controller name="opayoSandboxVendorName" control={control}
                                                        render={({ field, fieldState }) => (
                                                            <InputText id={field.name} {...field}
                                                            />
                                                        )}
                                            />
                                            <label htmlFor="opayoSandboxVendorName">Opayo SANDBOX Vendor Name</label>
                                        </span>
                                        {getFormErrorMessage('opayoSandboxVendorName')}
                                    </div>
                                    <div className="field col-6" style={{paddingTop: '27px'}}>
                                        <span className="p-float-label">
                                            <Controller name="opayoSandboxIntegrationKey" control={control}
                                                        render={({ field, fieldState }) => (
                                                            <InputText id={field.name} {...field}
                                                            />
                                                        )}
                                            />
                                            <label htmlFor="opayoSandboxIntegrationKey">Opayo SANDBOX Integration Key</label>
                                        </span>
                                        {getFormErrorMessage('opayoSandboxIntegrationKey')}
                                    </div>
                                    <div className="field col-6" style={{paddingTop: '27px'}}>
                                        <span className="p-float-label">
                                            <Controller name="opayoSandboxIntegrationPassword" control={control}
                                                        render={({ field, fieldState }) => (
                                                            <InputText id={field.name} {...field}
                                                            />
                                                        )}
                                            />
                                            <label htmlFor="opayoSandboxIntegrationPassword">Opayo SANDBOX Integration Password</label>
                                        </span>
                                        {getFormErrorMessage('opayoSandboxIntegrationPassword')}
                                    </div>
                                </div>
                            </>
                        }

                        <div className="col-12">
                            <div className="p-fluid grid">
                                <div className="field col-12 md:col-9"></div>
                                <div className="field col-12 md:col-3">
                                    <Button label="Update Opayo Settings"
                                            severity="warning"
                                            disabled={submitButtonDisabled}
                                            style={themeSettings.buttonColor ? {background: `#${themeSettings.buttonColor}`} : {background: '#f97316'}}
                                    />
                                </div>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </>
    )
}